'use client';

import { useEffect } from 'react';
import { useRouter, useParams } from 'next/navigation';

export default function WishlistRedirect() {
  const router = useRouter();
  const params = useParams();
  const locale = params?.locale || 'en';

  useEffect(() => {
    router.replace(`/${locale}/u/wishlist`);
  }, [router, locale]);

  return null;
}
